import { ChainType } from "@0xsquid/squid-types";
import { useMutation } from "@tanstack/react-query";
import { IBitcoinContextData } from "../../core/providers/BitcoinProvider";
import { BitcoinWallet, ConnectWalletResult } from "../../core/types/wallet";
import { useWalletStore } from "../store/useWalletStore";

export function useBitcoin(): IBitcoinContextData {
  const connectedBitcoinWallet = useWalletStore(
    (store) => store.connectedWalletsByChainType[ChainType.BTC]
  );
  const connectBitcoin = useMutation(
    async ({
      wallet,
    }: {
      wallet: BitcoinWallet;
    }): Promise<ConnectWalletResult<ChainType.BTC>> => {
      const { address } = await wallet.connector.requestAccount();

      return {
        wallet,
        address,
      };
    }
  );

  return {
    connectBitcoin,
    signer: connectedBitcoinWallet.wallet?.connector,
  };
}
